module.exports = __webpack_public_path__ + "img/logo_sheraton_b@3x.9c57a72c.png";